$.fn.isOnScreen = function (buffer = 300) {
  var win = $(window);

  var viewport = {
    top: win.scrollTop() - buffer,
    left: win.scrollLeft() - buffer,
  };
  viewport.right = viewport.left + win.width() + (buffer * 2);
  viewport.bottom = viewport.top + win.height() + (buffer * 2);

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

// OLD JQUERY

function loadPoductColors(cur, index) {
  if (!cur.hasClass("prod-loaded")) {
    cur.addClass("prod-loaded");

    var productTag = cur.data("prod-tags");
    
    // Parse de color map
    const colorMap = new Map();
    const colorMapString = cur.data("color-map");
    if (colorMapString) {
      colorMapString.split(',').forEach(pair => {
        const [number, hexColor] = pair.split(':');
        colorMap.set(number, hexColor);
      });
    }

    if (productTag) {
      $.get(
        "/search/suggest.json?type=product&q=variant_" +
          productTag +
          "&resources%5Boptions%5D%5Bfields%5D=tag",
        function (data) {
          var prodData = data.resources.results.products;
          var colorHtml = "";
          
          // Bijhouden van verwerkte URLs
          const processedUrls = new Set();

          $.each(prodData, function (index, product) {
            var url = "/products/" + product.handle;
            var productTags = product.tags;

            $.each(productTags, function (index, tag) {
              if (tag.indexOf("variant_") >= 0) {
                // Check of deze URL al is verwerkt
                if (processedUrls.has(url)) {
                  return; // Skip als de URL al bestaat
                }

                var tagSplit = tag.split("-");
                var variantColor = tagSplit[1];
                
                // Haal de hex kleur op uit de colorMap
                const hexColor = colorMap.get(variantColor) || '';
                let backgroundStyle = '';
                
                if (hexColor.includes('.SPLIT.')) {
                  const [color1, color2] = hexColor.split('.SPLIT.');
                  backgroundStyle = `background: linear-gradient(45deg, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
                } else {
                  backgroundStyle = `background-color: ${hexColor}`;
                }

                colorHtml += `
                  <li class="splide__slide">
                    <a href="${url}" 
                       class="product-card-color color-block-${variantColor}"
                       style="${backgroundStyle}">
                    </a>
                  </li>`;
                
                // Voeg URL toe aan verwerkte URLs
                processedUrls.add(url);
              }
            });
          });

          // Voeg de HTML toe aan de slider
          cur.find('.splide__list').html(colorHtml);
          
          // Initialiseer de Splide slider
          if (colorHtml !== "") {
            new Splide(cur.find('.splide')[0], {
              perPage: 7,
              gap: '0px',
              pagination: false,
              // fixedWidth: 15,
              // fixedHeight: 15,
              arrows: true,
              drag: true,
              perMove: 3,
              breakpoints: {
                640: {
                  perPage: 5
                }
              }
            }).mount();
          }
        }
      );
    }
  }
}

// PROMO COUNTDOWN SECTION
const PromoCountdown = class extends HTMLElement {
  connectedCallback() {
    console.log("PromoCountdown connected");
  }
};

if (!window.customElements.get("promo-countdown")) {
  window.customElements.define("promo-countdown", PromoCountdown);
}